import { render, staticRenderFns } from "./FederationsCombo.vue?vue&type=template&id=c285ddc0&scoped=true"
import script from "./FederationsCombo.vue?vue&type=script&lang=js"
export * from "./FederationsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c285ddc0",
  null
  
)

export default component.exports